/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LogoVkIcon16Light } from './LogoVkIcon16Light';
import { LogoVkIcon16Regular } from './LogoVkIcon16Regular';
import { LogoVkIcon16Solid } from './LogoVkIcon16Solid';
import { LogoVkIcon20Light } from './LogoVkIcon20Light';
import { LogoVkIcon20Regular } from './LogoVkIcon20Regular';
import { LogoVkIcon20Solid } from './LogoVkIcon20Solid';
import { LogoVkIcon24Regular } from './LogoVkIcon24Regular';
import { LogoVkIcon24Solid } from './LogoVkIcon24Solid';
import { LogoVkIcon32Regular } from './LogoVkIcon32Regular';
import { LogoVkIcon64Regular } from './LogoVkIcon64Regular';
var sizes = {
    16: {
        light: LogoVkIcon16Light,
        regular: LogoVkIcon16Regular,
        solid: LogoVkIcon16Solid,
    },
    20: {
        light: LogoVkIcon20Light,
        regular: LogoVkIcon20Regular,
        solid: LogoVkIcon20Solid,
    },
    24: {
        regular: LogoVkIcon24Regular,
        solid: LogoVkIcon24Solid,
    },
    32: {
        regular: LogoVkIcon32Regular,
    },
    64: {
        regular: LogoVkIcon64Regular,
    },
};
export var LogoVkIcon = forwardRef('LogoVkIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
